import { TransactionRowFragment } from 'services/graphql/fragments/Fragments';
import { PayOverTimeTransactionAnalyticsFragment } from 'services/graphql/fragments/PayOverTimeTransactionAnalytics';
import {
  IconFragment,
  VXLResponsiveTextFragment,
} from 'services/graphql/fragments/VxlStyles';
import { gql } from 'urql';

const smartViewTransactionsQuery = gql`
  query smartViewTransactions($input: SmartViewTransactionsInput!) {
    smartViewTransactions(input: $input) {
      ... on SLPaginatedPage {
        id
        pagingToken
        children {
          __typename
          ... on SLTitledListComponent {
            id
            icon {
              ...IconFragment
            }
            title {
              ...VXLResponsiveTextFragment
            }
            children {
              __typename
              ...TransactionRowFragment
              ...PayOverTimeTransactionAnalyticsFragment
            }
          }
        }
      }
    }
  }
  ${TransactionRowFragment}
  ${PayOverTimeTransactionAnalyticsFragment}
  ${VXLResponsiveTextFragment}
  ${IconFragment}
`;

export default smartViewTransactionsQuery;
